import './init';
import { WBFlex } from '@admiin-com/ds-web';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import ApolloClientProvider from './app/components/ApolloClientProvider/ApolloClientProvider';
import App from './app/App';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  (
    <ApolloClientProvider>
      <BrowserRouter>
        <Suspense fallback={<WBFlex />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </ApolloClientProvider>
  ) as any
);
